const mainSelector = '[itemprop="articleBody"]';

// const wrap = (toWrap, wrapper, tagName) => {
//   wrapper = wrapper || document.createElement(tagName);
//   toWrap.parentNode.appendChild(wrapper);
//   return wrapper.appendChild(toWrap);
// };

const formatImages = img => {

  if (img.parentElement && img.parentElement.hasAttribute('itemprop') && img.parentElement.getAttribute('itemprop') == 'articleBody') {
    const wrapper = document.createElement('figure');
    wrapper.classList.add('article-template__figure');
    // insert wrapper before el in the DOM tree
    img.parentNode.insertBefore(wrapper, img);
    // move el into wrapper
    wrapper.appendChild(img);
  } else if (img.parentElement && img.parentElement.tagName == 'P') {
    const imgHtml = img.outerHTML;
    img.parentElement.outerHTML = `
      <div class="article-template__figure">${imgHtml}</div>
    `;
  }

}

window.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll(`${mainSelector} img`).forEach(formatImages);

});